import { TFunction } from 'i18next'

import { AB488_SUPPORT_URL, OrganisationCardProps } from '@percent/domain/giving'
import { DONATION_DISALLOWED_ORG_COUNTRIES } from '@percent/workplace-giving/common/data/sanctionedCountries'
import { isUsaCalifornia } from '@percent/utility'
import {
  OrgAllowlistScope,
  OrgSearchFor
} from '@percent/workplace-giving/api/search/searchOrganisations/searchVerifiedOrganisations.types'

export const getDonationOptionsForOrg = ({
  orgCountryCode,
  ab488Compliant,
  donationsEnabled,
  userOrigin,
  t,
  blockedCountryCodes,
  allowlistScopes
}: {
  orgId: string
  orgCountryCode: string
  ab488Compliant: boolean
  donationsEnabled: boolean
  userOrigin: { country: string | null; state?: string | null }
  t: TFunction<'workplaceGiving', undefined>
  blockedCountryCodes?: string[]
  allowlistScopes?: OrgAllowlistScope[]
}): OrganisationCardProps['donationOptions'] => {
  const isCaliforniaUser = isUsaCalifornia(userOrigin.country, userOrigin.state)

  const isAllowlisted = (allowlistScopes?.length ?? 0) > 0

  if (!donationsEnabled) {
    return {
      kind: 'hidden'
    }
  }

  if (isAllowlisted && !allowlistScopes!.includes(OrgSearchFor.Donation)) {
    return {
      kind: 'hidden'
    }
  }

  if (!isAllowlisted && blockedCountryCodes?.includes(orgCountryCode)) {
    return {
      kind: 'disallowed',
      reason: t('workplace_giving.fundraiser.blockedCountryWarning')
    }
  }

  if (DONATION_DISALLOWED_ORG_COUNTRIES.includes(orgCountryCode)) {
    return {
      kind: 'disallowed',
      reason: t('workplace_giving.donate_information.notAvailable')
    }
  }

  if (isCaliforniaUser && !ab488Compliant) {
    return {
      kind: 'disallowed',
      reason: t('workplace_giving.search.ab488NonCompliant'),
      link: {
        text: t('workplace_giving.common.learnMore'),
        url: AB488_SUPPORT_URL
      }
    }
  }

  return {
    kind: 'allowed'
  }
}
